import CryptoJS from "crypto-js";

// 时间戳转换为 yyyy/mm/dd 00:00:00
export function formatTime(timestamp) {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}/${month}/${day} 00:00:00`;
}
export function normalizeUrl(url) {
  if (!url) return "";
  return url.replace(/([^:]\/)\/+/g, "$1");
}

// 加密密码
export const encryptPassword = (password) => {
  const encryptedPassword = CryptoJS.AES.encrypt(password, "secretKey").toString();
  return encryptedPassword;
};

// 解密密码
export const decryptPassword = (encryptedPassword) => {
  const bytes = CryptoJS.AES.decrypt(encryptedPassword, "secretKey");
  const decryptedPassword = bytes.toString(CryptoJS.enc.Utf8);
  return decryptedPassword;
};
